import { render } from "./KeyValue.vue?vue&type=template&id=5544791e&scoped=true"
import script from "./KeyValue.vue?vue&type=script&lang=js"
export * from "./KeyValue.vue?vue&type=script&lang=js"

import "./KeyValue.vue?vue&type=style&index=0&id=5544791e&lang=scss&scoped=true"

import exportComponent from "../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5544791e"]])

export default __exports__